import {writable} from 'svelte/store'

export const messages = writable([])

/* lines: [
	{from: 'client', line: 'DO STUFF'},
	{from: 'button', line: 'CLICK'},
	{from: 'control': line: 'Connected'},
	{from: 'server', line: 'DONEEE'},
]; */
const lines = []
export function push(from, line) {
	if (!line)
		return

	if ('string' !== typeof line) {
		try {
			line = line.toString()
		} catch (error) {
			line = 'Failed to log something. See browser console.'
			console.error(error)
		}
	}

	line = line.trim() + '\n'

	lines.push({from, line, time: (new Date)})
	messages.set(lines)
}

export default {messages, push}
